import classNames from 'classnames';

import styles from './mochi-card.module.scss';
export interface MochiCardProps {
  children: React.ReactNode;
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
}

export const MochiCard = ({ children, className }: MochiCardProps) => {
  return (
    <div className={classNames(styles['card'], className)}>{children}</div>
  );
};
